import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
        Richard Howard
    </div>
  );
}

export default App;
